import { AxiosInstance } from "axios";
import { axiosInstance, axiosJsonInstance } from "@/axios.instance";
import { AdvancedStatusFilter, AdvancedStatusFilterRequest } from "@/types/sv-data/system-view/advanced-filters/AdvancedStatusFilter";

class SystemViewAdvancedFiltersApi {
	private axios: AxiosInstance;
	private axiosJson: any;

	constructor() {
		this.axios = axiosInstance;
		this.axiosJson = axiosJsonInstance;
	}

	public async getAdvancedStatusFilters(request: AdvancedStatusFilterRequest): Promise<AdvancedStatusFilter[]> {
		let query = `/AdvancedStatusFilters?` +
			`searchTerm=${request.searchTerm}`;

		const { data } = await this.axiosJson.get(query);

		return data;
	}

	public async createAdvancedStatusFilter(advancedFilter: AdvancedStatusFilter): Promise<AdvancedStatusFilter> {
		return await this.axiosJson.post("/AdvancedStatusFilters", advancedFilter);
	}

	public async updateAdvancedStatusFilter(advancedFilter: AdvancedStatusFilter): Promise<AdvancedStatusFilter> {
		return await this.axiosJson.put("/AdvancedStatusFilters", advancedFilter);
	}

	public async deleteAdvancedStatusFilter(advancedStatusFilterId: number): Promise<any> {
		await this.axios.delete(`/AdvancedStatusFilters/${advancedStatusFilterId}`)
	}
}

const systemViewAdvancedFiltersApi = new SystemViewAdvancedFiltersApi();
export default systemViewAdvancedFiltersApi;
